/* Condü storefront — comportamiento global.
   - Cal.com: se carga SOLO al primer hover/foco/clic en un CTA de demo (o inline en /pages/demo).
   - Eventos: se publican con Shopify.analytics.publish → los consume un Custom Pixel
     (Settings → Customer events). Ningún pixel ni ID vive en el tema.
   - Sin API keys: el embed de Cal.com no necesita ninguna. */
(function () {
  'use strict';

  var W = window;
  var D = document;
  var CFG = W.conduConfig || {};
  var NS = CFG.calNs || 'demo';
  var CAL_LINK = CFG.calLink || 'condu.mx/demo';
  var CAL_SCRIPT = 'https://app.cal.com/embed/embed.js';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  var money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
  var reduceMotion = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- storage seguro ---------- */
  function readJSON(key) {
    try { return JSON.parse(W.sessionStorage.getItem(key) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeJSON(key, val) {
    try { W.sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* modo privado */ }
  }

  /* ---------- UTMs persistidos en la sesión ---------- */
  var utm = (function () {
    var saved = readJSON('condu_utm');
    var q = new URLSearchParams(W.location.search);
    var changed = false;
    UTM_KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v) { saved[k] = v.slice(0, 120); changed = true; }
    });
    if (changed) writeJSON('condu_utm', saved);
    return saved;
  })();

  function ctx(patch) {
    var c = readJSON('condu_ctx');
    if (patch) { for (var k in patch) c[k] = patch[k]; writeJSON('condu_ctx', c); }
    return c;
  }

  /* ---------- Analítica (Customer Events) ---------- */
  function track(name, data) {
    var payload = {};
    var k;
    for (k in utm) payload[k] = utm[k];
    if (data) for (k in data) payload[k] = data[k];
    payload.page = W.location.pathname;
    try {
      if (W.Shopify && W.Shopify.analytics && typeof W.Shopify.analytics.publish === 'function') {
        W.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* no-op */ }
  }
  W.conduTrack = track;

  /* ---------- Cal.com (embed oficial, lazy) ---------- */
  var calPromise = null;

  function loadCal() {
    if (calPromise) return calPromise;
    calPromise = new Promise(function (resolve, reject) {
      /* Snippet oficial del embed de Cal.com */
      (function (C, A, L) {
        var p = function (a, ar) { a.q.push(ar); };
        var d = C.document;
        C.Cal = C.Cal || function () {
          var cal = C.Cal;
          var ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            var s = d.createElement('script');
            s.src = A;
            s.async = true;
            s.onload = function () { resolve(); };
            s.onerror = function () { reject(new Error('cal-load')); };
            d.head.appendChild(s);
            cal.loaded = true;
          }
          if (ar[0] === L) {
            var api = function () { p(api, arguments); };
            var namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === 'string') {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ['initNamespace', namespace]);
            } else p(cal, ar);
            return;
          }
          p(cal, ar);
        };
      })(W, CAL_SCRIPT, 'init');

      W.Cal('init', NS, { origin: 'https://cal.com' });
      W.Cal.ns[NS]('ui', {
        theme: 'dark',
        cssVarsPerTheme: { dark: { 'cal-brand': '#CBA14D' }, light: { 'cal-brand': '#A9832F' } },
        hideEventTypeDetails: false,
        layout: 'month_view'
      });
      // Cal.com documenta bookingSuccessfulV2; se escucha también la versión anterior por compatibilidad.
      W.Cal.ns[NS]('on', { action: 'bookingSuccessfulV2', callback: onBooked });
      W.Cal.ns[NS]('on', { action: 'bookingSuccessful', callback: onBooked });
      setTimeout(function () { reject(new Error('cal-timeout')); }, 8000);
    });
    return calPromise;
  }

  var booked = false;
  function onBooked(e) {
    if (booked) return;
    booked = true;
    var c = ctx();
    track('demo_booked', { plan: c.plan || '', unidades: c.unidades || '' });
    var url = CFG.thanksUrl || '/pages/gracias';
    setTimeout(function () { W.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'agendado=1'; }, 900);
  }

  function calConfig(extra) {
    var c = ctx();
    var plan = (extra && extra.plan) || c.plan || '';
    var notes = [];
    if (plan) notes.push('Plan de interés: ' + plan);
    if (c.unidades) notes.push('Unidades: ' + c.unidades);
    var cfg = { layout: 'month_view', theme: 'dark' };
    if (notes.length) cfg.notes = notes.join(' · ');
    if (plan) cfg['metadata[plan]'] = plan;
    if (c.unidades) cfg['metadata[unidades]'] = String(c.unidades);
    if (c.perdida) cfg['metadata[perdida_anual]'] = String(c.perdida);
    UTM_KEYS.forEach(function (k) { if (utm[k]) cfg[k] = utm[k]; });
    return cfg;
  }

  function calUrl(extra) {
    var cfg = calConfig(extra);
    var q = new URLSearchParams();
    for (var k in cfg) if (k !== 'theme') q.set(k, cfg[k]);
    return 'https://cal.com/' + CAL_LINK + '?' + q.toString();
  }

  function openDemo(el) {
    var plan = el.getAttribute('data-plan') || '';
    if (plan) ctx({ plan: plan });
    track('cta_demo_click', { location: el.getAttribute('data-loc') || '', plan: plan });
    var fallback = calUrl({ plan: plan });
    loadCal().then(function () {
      W.Cal.ns[NS]('modal', { calLink: CAL_LINK, config: calConfig({ plan: plan }) });
    }).catch(function () {
      W.location.href = fallback;
    });
  }

  function mountInline(el) {
    el.setAttribute('aria-busy', 'true');
    loadCal().then(function () {
      var target = el.querySelector('[data-cal-target]') || el;
      W.Cal.ns[NS]('inline', { elementOrSelector: target, calLink: CAL_LINK, config: calConfig() });
      el.classList.add('is-loaded');
      el.removeAttribute('aria-busy');
    }).catch(function () {
      el.classList.add('is-failed');
      el.removeAttribute('aria-busy');
    });
  }

  /* Delegación: precarga en intención, abre en clic */
  function demoTarget(e) { return e.target && e.target.closest ? e.target.closest('[data-condu-demo]') : null; }
  D.addEventListener('pointerover', function (e) { if (demoTarget(e)) loadCal().catch(function () {}); }, { passive: true });
  D.addEventListener('focusin', function (e) { if (demoTarget(e)) loadCal().catch(function () {}); });
  D.addEventListener('touchstart', function (e) { if (demoTarget(e)) loadCal().catch(function () {}); }, { passive: true });
  D.addEventListener('click', function (e) {
    var el = demoTarget(e);
    if (el) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      openDemo(el);
      return;
    }
    var wa = e.target && e.target.closest ? e.target.closest('[data-condu-wa]') : null;
    if (wa) {
      wa.href = waHref(wa.getAttribute('data-msg'));
      track('whatsapp_click', { location: wa.getAttribute('data-loc') || '' });
    }
  });

  /* ---------- WhatsApp con contexto/UTM ---------- */
  function waHref(msg) {
    var text = msg || CFG.waMsg || 'Hola Condü, quiero información para mi condominio';
    var c = ctx();
    if (c.plan) text += ' (plan ' + c.plan + ')';
    if (c.unidades) text += ' · ' + c.unidades + ' unidades';
    var ref = [utm.utm_source, utm.utm_campaign].filter(Boolean).join('/');
    if (ref) text += ' [ref: ' + ref + ']';
    return 'https://wa.me/' + (CFG.wa || '523319518735') + '?text=' + encodeURIComponent(text);
  }

  /* ---------- Planes ---------- */
  var PLANS = CFG.plans || [];
  function recommend(units) {
    for (var i = 0; i < PLANS.length; i++) if (units <= PLANS[i].units) return PLANS[i];
    return null;
  }

  /* ---------- Calculadora de morosidad ---------- */
  function initCalc(root) {
    var form = root.querySelector('form');
    var full = root.getAttribute('data-mode') === 'full';
    var out = {
      big: root.querySelector('[data-out="loss"]'),
      monthly: root.querySelector('[data-out="monthly"]'),
      late: root.querySelector('[data-out="late"]'),
      plan: root.querySelector('[data-out="plan"]'),
      cost: root.querySelector('[data-out="cost"]'),
      breakeven: root.querySelector('[data-out="breakeven"]'),
      formula: root.querySelector('[data-out="formula"]')
    };
    var reported = '';

    function num(name) {
      var v = parseFloat((form.elements[name] && form.elements[name].value) || '0');
      return isFinite(v) && v > 0 ? v : 0;
    }

    function compute(fromSubmit) {
      var units = Math.round(num('unidades'));
      var fee = num('cuota');
      var pct = Math.min(num('morosidad'), 100);
      if (!units || !fee || !pct) {
        if (fromSubmit) {
          var first = ['unidades', 'cuota', 'morosidad'].filter(function (n) { return !num(n); })[0];
          if (first && form.elements[first]) form.elements[first].focus();
        }
        return;
      }
      var lateUnits = units * pct / 100;
      var monthly = lateUnits * fee;
      var annual = Math.round(monthly * 12);
      root.setAttribute('data-state', 'done');
      if (out.big) out.big.textContent = money.format(annual);
      if (out.monthly) out.monthly.textContent = money.format(Math.round(monthly));
      if (out.late) out.late.textContent = (Math.round(lateUnits * 10) / 10).toLocaleString('es-MX');
      if (out.formula) out.formula.textContent = units + ' × ' + money.format(fee) + ' × ' + pct + '% × 12';

      var c = { unidades: units, perdida: annual };
      if (full) {
        var plan = recommend(units);
        if (plan) {
          var monthlyCost = Math.round(plan.price * (CFG.annualMonths || 10) / 12);
          var needed = Math.max(1, Math.ceil(monthlyCost / fee));
          if (out.plan) out.plan.textContent = plan.name;
          if (out.cost) out.cost.textContent = money.format(monthlyCost);
          if (out.breakeven) out.breakeven.textContent = needed === 1 ? '1 pago atrasado al mes' : needed + ' pagos atrasados al mes';
          c.plan = plan.key;
          root.classList.remove('is-custom');
        } else {
          root.classList.add('is-custom');
          if (out.plan) out.plan.textContent = 'A la medida';
        }
      }
      ctx(c);
      var sig = units + '|' + fee + '|' + pct;
      if (sig !== reported) {
        reported = sig;
        track('calculator_complete', { unidades: units, cuota: fee, morosidad: pct, perdida_anual: annual });
      }
      if (fromSubmit) {
        var res = root.querySelector('.cd-result');
        if (res && W.innerWidth < 990) res.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); compute(true); });
    form.addEventListener('input', function () { if (root.getAttribute('data-state') === 'done') compute(false); });
  }

  /* ---------- Precios: toggle anual/mensual + selector de unidades ---------- */
  function initPricing(root) {
    var buttons = root.querySelectorAll('[data-set-cycle]');
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var cycle = b.getAttribute('data-set-cycle');
        root.setAttribute('data-cycle', cycle);
        buttons.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        track('plan_toggle_annual', { ciclo: cycle });
      });
    });

    var range = root.querySelector('[data-units]');
    if (!range) return;
    var val = root.querySelector('[data-units-val]');
    var msg = root.querySelector('[data-units-msg]');
    function update() {
      var u = parseInt(range.value, 10) || 0;
      if (val) val.textContent = u >= 600 ? '600+' : u;
      var plan = recommend(u);
      root.querySelectorAll('[data-plan-card]').forEach(function (card) {
        card.classList.toggle('is-recommended', !!plan && card.getAttribute('data-plan-card') === plan.key);
      });
      var custom = root.querySelector('[data-plan-card="custom"]');
      if (custom) custom.classList.toggle('is-recommended', !plan);
      if (msg) msg.textContent = plan ? 'Te recomendamos ' + plan.name + ' (hasta ' + plan.units + ' unidades).' : 'Con más de 400 unidades te armamos un plan a la medida.';
      ctx({ unidades: u, plan: plan ? plan.key : 'a-la-medida' });
    }
    range.addEventListener('input', update);
    update();
  }

  /* ---------- Chat del hero: animación secuencial al entrar en vista ---------- */
  function initChat(chat) {
    if (reduceMotion || !('IntersectionObserver' in W)) return;
    chat.classList.add('cd-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { chat.classList.add('is-playing'); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(chat);
  }

  function init() {
    var tc = D.querySelector('meta[name="theme-color"]');
    if (tc) tc.setAttribute('content', '#0D1B2A');
    D.querySelectorAll('[data-condu-calc]').forEach(initCalc);
    D.querySelectorAll('[data-condu-pricing]').forEach(initPricing);
    D.querySelectorAll('[data-condu-chat]').forEach(initChat);
    D.querySelectorAll('[data-condu-cal-inline]').forEach(mountInline);
    if (D.querySelector('[data-condu-pricing]')) track('pricing_view', {});
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();

  /* Editor de temas: re-inicializa secciones recargadas */
  D.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    t.querySelectorAll('[data-condu-calc]').forEach(initCalc);
    t.querySelectorAll('[data-condu-pricing]').forEach(initPricing);
    t.querySelectorAll('[data-condu-chat]').forEach(function (c) { c.classList.remove('cd-anim'); });
  });
})();
